import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({className=''}: Props) => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M8 3.17255e-05L16 8.00003L14.1333 9.8667L8 3.73337L1.86667 9.8667L1.63189e-07 8.00003L8 3.17255e-05Z"
      fill="#0B57D0" className={className}
    />
  </svg>
);

export default Icon;
